'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import Loading from '@/app/components/CommonLayout/Loading';
import { usePermissions } from '@/hooks/usePermissions';

export default function Home() {
  const router = useRouter();
  const { MenuSidebar } = usePermissions();

  useEffect(() => {
    const theFirstRoute = MenuSidebar[0];
    router.replace(theFirstRoute.sub?.[0].path ?? theFirstRoute.path);
  }, [MenuSidebar, router]);

  return <Loading />;
}
